





































import { Component, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'

import {
  DeliverySettingsForm,
  ConfirmLeaveModal,
  NetworkErrorEmptyState,
  VsLoading
} from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  BusinessUnit,
  DeliverySettings,
  DeliverySettingsResourcePayload,
  ModalState
} from '@/models'

@Component({
  components: {
    DeliverySettingsForm,
    ConfirmLeaveModal,
    MobileLayout,
    NetworkErrorEmptyState,
    VsLoading
  }
})
export default class DeliverySettingsView extends Vue {
  isReady = false

  loadState = new AsyncState()
  createOrUpdateState = new AsyncState()
  confirmLeaveState = new ModalState()

  data: DeliverySettingsResourcePayload | null = null
  isValid = false

  get buttons (): ActionButton[] {
    if (!this.loadState.isResolved) {
      return []
    }

    return [
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.createOrUpdateState.isPending
      }
    ]
  }

  get hasChanges () {
    const data = this.data
    const deliverySettings = this.deliverySettings

    if (deliverySettings === null) {
      return data && (
        data.phone !== null ||
        data.slug !== null
      )
    }

    return data !== null && deliverySettings !== null && (
      data.phone !== deliverySettings.phone ||
      data.slug !== deliverySettings.slug ||
      data.active !== deliverySettings.isActive ||
      data.fee !== deliverySettings.fee
    )
  }

  @State
  readonly deliverySettings!: DeliverySettings | null

  @State
  readonly businessUnit!: BusinessUnit | null

  @Action
  loadDeliverySettings!: () => Promise<void>

  @Action
  createOrUpdateDeliverySettings!: (payload: DeliverySettingsResourcePayload) => Promise<void>

  async created () {
    if (this.deliverySettings === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.deliverySettings !== null) {
      this.data = {
        shopId: this.deliverySettings.businessUnitId,
        phone: this.deliverySettings.phone,
        slug: this.deliverySettings.slug,
        active: this.deliverySettings.isActive,
        fee: this.deliverySettings.fee
      }
    }

    this.isReady = true
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadDeliverySettings()
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.createOrUpdateState.handle(
        this.createOrUpdateDeliverySettings(this.data)
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.$router.back()
    }
  }
}
